/**
 * Shorten free text to a title: `max` characters at most, cut at a word
 * boundary and marked with an ellipsis (#958). A bare `slice(0, 60)` cut
 * "...pending approval" to "...pending approva".
 *
 * Whitespace runs (including the newlines of a multi-line prompt) collapse to
 * single spaces first — a title is one line. A single word longer than half
 * the budget is hard-cut rather than dropping everything after the last space.
 */
export const truncateAtWord = (text: string, max: number): string => {
  const flat = text.replace(/\s+/g, ' ').trim();
  if (flat.length <= max) return flat;

  // One character is reserved for the ellipsis.
  const head = flat.slice(0, max - 1);
  const lastSpace = head.lastIndexOf(' ');
  const cut = lastSpace >= Math.floor(max / 2) ? head.slice(0, lastSpace) : head;
  // "approvals, …" reads worse than "approvals…"
  return `${cut.replace(/[\s.,;:!?-]+$/, '')}…`;
};
